import {
    REQUEST_ROOMS_LIST,
    SET_ROOMS_LIST,
    SET_PAGE,
    OPEN_MODAL_CREATE_CHANNEL,
    CLOSE_MODAL_CREATE_CHANNEL,
    REQUEST_CREATE_CHANNEL,
    SUCCESS_CREATE_CHANNEL,
    REQUEST_DELETE_ROOM
} from './constants'

export function requestRoomsList(page = 1, filter = '') {
    return {
        type: REQUEST_ROOMS_LIST,
        payload: {
            page,
            filter
        }
    }
}

export function setRoomsList({ rooms, pagination }) {
    return {
        type: SET_ROOMS_LIST,
        payload: {
            rooms,
            pagination
        }
    }
}

export function setPage({ page }) {
    return {
        type: SET_PAGE,
        payload: {
            page
        }
    }
}

export function openModalCreateChannel() {
    return {
        type: OPEN_MODAL_CREATE_CHANNEL,
        payload: {}
    }
}

export function closeModalCreateChannel() {
    return {
        type: CLOSE_MODAL_CREATE_CHANNEL,
        payload: {}
    }
}

export function requestCreateChannel(params = {}) {
    return {
        type: REQUEST_CREATE_CHANNEL,
        payload: params
    }
}

export function successCreateChannel() {
    return {
        type: SUCCESS_CREATE_CHANNEL,
        payload: {}
    }
}

export function requestDeleteRoom({ roomId, filter }) {
    return {
        type: REQUEST_DELETE_ROOM,
        payload: {
            roomId,
            filter
        }
    }
}
